import React, { useState } from "react";
import { toast } from "react-toastify";
import PageLoader from "../../components/PageLoader";
import LoggedInLayout from "../../layouts/loggedinlayout";
import { Constants } from "../../libs/Constants";
import { getList } from "../../libs/dbFunctions";
import Approvals from "./Approvals";


const ApprovalRequests = ({ activeCompany }) => {
    const [loading, setLoading] = useState(false);
    const [approvals, setApprovals] = React.useState([]);

    React.useEffect(() => {
        // Load initial date filters
        loadApprovals();
    }, []);
    async function loadApprovals() {
        setLoading(true);
        try {
            const objects = await getList(
                Constants.dbTypes.APPROVAL_REQUEST,
                activeCompany
            );
            if (objects) {
                setApprovals(objects);
            }
        } catch (err) {
            toast.error("unable to load approvals.");
        }
        setLoading(false);
    }
    return (
        <LoggedInLayout title="Approval Requests">
            <PageLoader isActive={loading}>
                <Approvals
                    approvals={approvals}
                    onSuccess={() => {
                        loadApprovals();
                    }}
                />
            </PageLoader>
        </LoggedInLayout>
    );
};

export default ApprovalRequests;
